import React from 'react';
import {strategyPrice} from 'utils/mixins';
import {MoneyBack} from './icons';
import './price.scss';

const Price = ({price, moneyBack}) => (
  <div className="price-container">
    <div className="price">
      <div className="value">{strategyPrice(price)}</div>
      <div className="title">Price</div>
    </div>
    <div className="money-back">
      <MoneyBack />
      <div className="info">
        <div className="value green">{moneyBack || 0}%</div>
        <div className="title">Money back</div>
      </div>
    </div>
  </div>
);

export default Price;
